import { render, staticRenderFns } from "./OmaProcedure.vue?vue&type=template&id=4ba8c59f"
import script from "./OmaProcedure.vue?vue&type=script&lang=js"
export * from "./OmaProcedure.vue?vue&type=script&lang=js"
import style0 from "./OmaProcedure.vue?vue&type=style&index=0&id=4ba8c59f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports